import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export default function SignIn(props) {

  const showUnlockStyling = {
    width: '100%',
    // backgroundColor: '#3B4E68',
    // border: '1px solid #3B4E68',
    padding: '10px',
    // color: '#FFFFFF',
    // '&:hover': {
    //   color: '#3B4E68',
    //   border: '1px solid #3B4E68',
    //   backgroundColor: '#60A5FA',
    // }

    backgroundColor: 'red',
    border: '1px solid #3B4E68',
    // color: '#FFFFFF',
    color: '#FFFFFF',
  }

  const normalUnlockStyling = {
    width: '100%',
    backgroundColor: '#3B4E68',
    border: '1px solid #3B4E68',
    padding: '10px',
    color: '#FFFFFF',
    '&:hover': {
      color: '#3B4E68',
      border: '1px solid #3B4E68',
      backgroundColor: '#60A5FA',
    }
  }

  return (
    <Box sx={{
      padding: '20px',
      paddingTop: 0,
      paddingBottom: 0,
    }}>
      <Button
        variant="contained"
        // endIcon={<SendIcon
        //   sx={{
        //     color: '#3B4E68',
        //     fontSize: '3rem',
        //   }} />}
        // sx={{
        //   width: '100%',
        //   backgroundColor: '#3B4E68',
        //   border: '1px solid #3B4E68',
        //   padding: '10px',
        //   color: '#FFFFFF',
        //   '&:hover': {
        //     color: '#3B4E68',
        //     border: '1px solid #3B4E68',
        //     backgroundColor: '#60A5FA',
        //   }
        // }}
        sx={props.showUnlockButton ? showUnlockStyling : normalUnlockStyling}
        onClick={props.handler}
        disabled={props.disable ? true : props.clicked == 6 ? false : true}
      >
        Unlock
      </Button>
    </Box >
  );

}